export default "__VITE_ASSET__C6e2yP0O__"